import * as React from 'react';
import { getSeason, getTimesOfDay } from '../../utils';

export default class Time extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      timestamp: this.props.info.timestamp,
      date: new Date().toLocaleString('en-US', { timeZone: this.timestamp }),
    };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
    this.getInfoForChangeImg();
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
    this.getInfoForChangeImg();
  }

  getInfoForChangeImg() {
    const { info } = this.props;
    const { date } = this.state;

    const season = getSeason(new Date(date).getMonth());
    const timesOfDay = getTimesOfDay(new Date(date).getHours());

    return info.changeImage(season, timesOfDay);
  }

  tick() {
    this.setState({
      date: new Date().toLocaleString('en-US', {
        timeZone: this.props.info.timestamp,
      }),
    });
  }

  render() {
    // const months = [
    //   'January',
    //   'February',
    //   'March',
    //   'April',
    //   'May',
    //   'June',
    //   'July',
    //   'August',
    //   'September',
    //   'October',
    //   'November',
    //   'December',
    // ];

    const { date } = this.state;

    const dayOfWeek = this.props.info.langDay[new Date(date).getDay()];
    const dayOfMonth = new Date(date).getDate();
    const curMonth = this.props.info.langMonth[new Date(date).getMonth()];
    const curHours = new Date(date).getHours();
    const curMinutes = new Date(date).getMinutes();
    const curSeconds = new Date(date).getSeconds();

    const setCorrectTime = (item) => {
      if (item < 10) {
        return `0${item}`;
      }
      return item;
    };
    return (
      <h3 className="date">
        {`${dayOfWeek} ${dayOfMonth} ${curMonth}`}, {setCorrectTime(curHours)}:
        {setCorrectTime(curMinutes)}:{setCorrectTime(curSeconds)}
      </h3>
    );
  }
}
